import Vue from 'vue';
import './plugins/axios';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import VueI18n from 'vue-i18n';
import storage from './helpers/storage.js';
import moment from 'moment';

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import './assets/style.css' // Global stilni import qilamiz

Vue.prototype.moment = moment;
Vue.prototype.storage = storage;

Vue.use(VueI18n);
const axios = require('axios').default;

// 🌐 Til sozlamalari
import en from '@/components/languages/en';
import ru from '@/components/languages/ru';
import '@mdi/font/css/materialdesignicons.css';

let locale = store.state.locale || 'en';
if (!store.state.locale) {
  store.dispatch('setLocale', locale);
}

const i18n = new VueI18n({
  locale,
  silentTranslationWarn: true,
  messages: { en, ru },
});

// 🌈 Tema: light/dark vuetify
import Vuetify from 'vuetify/lib';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

// ⬛ Taniqli tanishuv ranglari (rose + indigo)
const isDark = localStorage.getItem('userTheme') === 'dark';
const vuetify = new Vuetify({
  theme: {
    dark: isDark,
    icons: {
      iconfont: 'mdi', // Material Design Icons
    },
    themes: {
      light: {
        primary: '#E91E63',     // Rose Pink
        secondary: '#3F51B5',   // Indigo
        background: '#FFF8F9',  // Cream white
        darkPrimary: '#2E2B30', // Light Pink
        iconDarkColor: '#38114F'
      },
      dark: {
        primary: '#F06292',     // Light Pink
        secondary: '#7986CB',   // Soft Indigo
        background: '#121212',  // Deep gray
      },
    },
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  axios,
  render: h => h(App)
}).$mount('#app');
